import { render, staticRenderFns } from "./BindingVendorApiConfig.vue?vue&type=template&id=8d080ccc&lang=pug&"
import script from "./BindingVendorApiConfig.vue?vue&type=script&lang=ts&"
export * from "./BindingVendorApiConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports